<div class="dialog-split-layout">
	<!-- Form Sidebar -->
	<div class="form-sidebar">
		<div class="dialog-header">
			<h1 mat-dialog-title *ngIf="form?.value.name" class="m-0">{{ form?.value.name }}</h1>
			<h1 mat-dialog-title *ngIf="!form?.value.name" i18n="Add Content Section@@contentSectionDialogAddContentSection" class="m-0">Add Content Section</h1>
			<mat-icon [mat-dialog-close]="null" class="cursor-pointer primary-color">close</mat-icon>
		</div>

		<div class="form-content mt-5">
	<ng-container *ngIf="form">
		<form [formGroup]="form">
			<app-text-input
				class="block full-width mb-3"
				[parentForm]="form"
				[fullWidth]="true"
				[controlName]="'name'"
				label="Name"
				i18n-label="Name Label@@contentSectionDialogNameLabel"
				placeholder="Internal name of the section."
				i18n-placeholder="Name Placeholder@@contentSectionDialogNamePlaceholder"
			></app-text-input>

			<app-text-input
				class="block full-width mb-3"
				[parentForm]="form"
				[fullWidth]="true"
				[controlName]="'title'"
				label="Title"
				i18n-label="Title Label@@contentSectionDialogTitleLabel"
				placeholder="Title of the section."
				i18n-placeholder="Title Placeholder@@contentSectionDialogTitlePlaceholder"
				[showLocale]="true"
				[localeData]="sectionLocales?.title"
				(localeChange)="updateLocale('title', $event)"
			></app-text-input>

			<app-text-input
				class="block full-width mb-6"
				[parentForm]="form"
				[fullWidth]="true"
				[controlName]="'subtitle'"
				label="Subtitle"
				i18n-label="Subtitle Label@@contentSectionDialogSubtitleLabel"
				placeholder="Subtitle of the section."
				i18n-placeholder="Subtitle Placeholder@@contentSectionDialogSubtitlePlaceholder"
				[showLocale]="true"
				[localeData]="sectionLocales?.subtitle"
				(localeChange)="updateLocale('subtitle', $event)"
			></app-text-input>

			<app-toggle-input
				class="block full-width mb-3"
				[currentValue]="form.value?.body !== null"
				[fullWidth]="true"
				[controlName]="'body'"
				label="Enable Body Content"
				i18n-label="Enable Body Content Label@@contentSectionDialogEnableBodyContentLabel"
				(valueChange)="form.controls.body.setValue($event ? 'Enter Content Here' : null)"
			>
			</app-toggle-input>

			<app-toggle-input
				*ngIf="isSuperAdmin && form.value?.body !== null"
				class="block full-width mb-3"
				[currentValue]="form.value?.sanitizeHtml"
				[fullWidth]="true"
				[controlName]="'sanitizeHtml'"
				label="Sanitize HTML"
				i18n-label="Sanitize HTML Label@@contentSectionDialogSanitizeHtmlLabel"
				(valueChange)="form.controls.sanitizeHtml.setValue($event)"
			>
			</app-toggle-input>

			<div *ngIf="form.value?.body !== null" class="mb-6">
				<app-wysiwyg-input
					class="block full-width quill-editor"
					[currentValue]="form.value?.body"
					[debounceTime]="300"
					toolbar="complex"
					placeholder="Body of the section."
					i18n-placeholder="Body Placeholder@@contentSectionDialogBodyPlaceholder"
					hint="Use data-event and data-args to trigger custom events. Refer to docs for available custom events."
					i18n-hint="Body Hint@@contentSectionDialogBodyHint"
					(valueChange)="form.controls.body.setValue($event ?? '')"
				></app-wysiwyg-input>
			</div>


			<div class="mb-6" [formGroup]="form.controls.templates">
				<app-toggle-input
					class="block full-width mb-3"
					[parentForm]="form.controls.templates"
					[fullWidth]="true"
					[controlName]="'enabled'"
					label="Enable Template Grid"
					i18n-label="Enable Template Grid Label@@contentSectionDialogEnableTemplateGridLabel">
				</app-toggle-input>

				<!-- Template Grid -->
				<div class="mb-3">
					<app-toggle-input
						[currentValue]="form.value?.useTemplates"
						[fullWidth]="true"
						label="Get Templates Instead of Template Listings"
						i18n-label="Get Templates Label@@contentSectionDialogGetTemplatesLabel"
						(valueChange)="form.controls.useTemplates.setValue($event)"
					></app-toggle-input>
				</div>

				<ng-container *ngIf="form.value.templates?.enabled">
					<h3 class="mb-3" i18n="Filters Label@@contentSectionDialogFiltersLabel">Filters:</h3>

					<app-toggle-input
						class="block full-width mb-3"
						[currentValue]="form.value?.filterByProjectBusiness"
						[fullWidth]="true"
						label="Filter by Project Business"
						i18n-label="Filter by Project Business Label@@contentSectionDialogFilterByProjectBusinessLabel"
						(valueChange)="form.controls.filterByProjectBusiness.setValue($event)"
					></app-toggle-input>

					<app-creative-unit-package-category-picker
						class="mb-3 block full-width"
						[selected]="form.value?.templates?.categories"
						(selectedChange)="setTemplatesProperty('categories', $event)"
					></app-creative-unit-package-category-picker>

					<app-multiselect-input
						class="mb-3 block full-width"
						[parentForm]="form.controls.templates"
						[fullWidth]="true"
						hint="Use lowercase letters and dashes. Example: my-tag"
						i18n-hint="Tags Hint@@contentSectionDialogTagsHint"
						[controlName]="'tags'"
						label="Filter by Tags"
						i18n-label="Tags Label@@contentSectionDialogTagsLabel"
						placeholder="Add tags..."
						i18n-placeholder="Tags Placeholder@@contentSectionDialogTagsPlaceholder"
						[allowCustomValues]="true"
					>
					</app-multiselect-input>

					<app-multiselect-input
						class="mb-3 block full-width"
						[parentForm]="form.controls.templates"
						[fullWidth]="true"
						[controlName]="'ids'"
						[enableRemoteSearch]="true"
						[remoteSearchService]="creativeUnitPackageListingService"
						[optionValueKey]="'id'"
						[optionLabelKey]="'name'"
						[sublineKey]="'tags'"
						label="Get Specific Template Listings"
						i18n-label="Get Specific Template Listings Label@@contentSectionDialogGetSpecificTemplateListingsLabel"
						placeholder=" of template listings"
						i18n-placeholder="Get Specific Template Listings Placeholder@@contentSectionDialogGetSpecificTemplateListingsPlaceholder"
						hint="Templates are shown in the order they are added."
						i18n-hint="Get Specific Template Listings Hint@@contentSectionDialogGetSpecificTemplateListingsHint"
					>
					</app-multiselect-input>

					<app-select-input
						class="block full-width mb-3"
						[parentForm]="form.controls.templates"
						[fullWidth]="true"
						[controlName]="'layout'"
						label="Grid Layout"
						i18n-label="Layout Label@@contentSectionDialogLayoutLabel"
						[optionValueKey]="'value'"
						[optionLabelKey]="'label'"
						[options]="[
							{ value: undefined, label: 'Default' },
							{ value: 'grid-2', label: '2 Card Rows' },
							{ value: 'grid-3', label: '3 Card Rows' },
							{ value: 'grid-4', label: '4 Card Rows' },
							{ value: 'grid-5', label: '5 Card Rows' },
							{ value: 'grid-6', label: '6 Card Rows' },
							{ value: 'grid-7', label: '7 Card Rows' }
						]"
					></app-select-input>

					<app-select-input
						class="block full-width mb-3"
						[parentForm]="form.controls.templates"
						[fullWidth]="true"
						[controlName]="'thumbnailStyle'"
						label="Thumbnail Style"
						i18n-label="Thumbnail Style@@contentSectionDialogThumbnailStyleLabel"
						[optionValueKey]="'value'"
						[options]="[
							{ value: 'contain', label: 'Contain' },
							{ value: 'cover', label: 'Cover' }
						]"
					></app-select-input>

					<div class="mt-6 mb-6" [formGroup]="form.controls.searchbar">
						<app-toggle-input
							class="block full-width mb-3"
							[parentForm]="form.controls.searchbar"
							[fullWidth]="true"
							[controlName]="'enabled'"
							label="Enable Searchbar"
							i18n-label="Enable Searchbar Label@@contentSectionDialogEnableSearchbarLabel"
						></app-toggle-input>

						<ng-container *ngIf="form.value?.searchbar?.enabled">
							<app-text-input
								class="block full-width mb-3"
								[parentForm]="form.controls.searchbar"
								[fullWidth]="true"
								[controlName]="'label'"
								label="Searchbar Label Text"
								i18n-label="Searchbar Label Text Label@@contentSectionSearchbarLabelTextLabel"
								[showLocale]="true"
								[localeData]="sectionLocales?.['searchbar.label']"
								(localeChange)="updateLocale('searchbar.label', $event)"
							></app-text-input>

							<app-text-input
								class="block full-width mb-3"
								[parentForm]="form.controls.searchbar"
								[fullWidth]="true"
								[controlName]="'placeholder'"
								label="Searchbar Placeholder Text"
								i18n-label="Searchbar Placeholder Text Label@@contentSectionSearchbarPlaceholderTextLabel"
								[showLocale]="true"
								[localeData]="sectionLocales?.['searchbar.placeholder']"
								(localeChange)="updateLocale('searchbar.placeholder', $event)"
							></app-text-input>
						</ng-container>
					</div>
				</ng-container>
			</div>

			<button type="submit" style="display: none;"></button>

			<ng-container [formGroup]="form.controls.paginator">
				<div class="mb-6">
					<app-multiselect-input
						class="mb-3 block full-width"
						[parentForm]="form.controls.paginator"
						[fullWidth]="true"
						[controlName]="'pageSizeOptions'"
						label="Page Size Options"
						i18n-label="Page size Label@@contentSectionDialogPageSizeOptionsLabel"
						placeholder="New page size options..."
						i18n-placeholder="Page Size Placeholder@@contentSectionDialogPageSizeOptionsPlaceholder"
						[allowCustomValues]="true"
					>
					</app-multiselect-input>

					<app-select-input
						class="mb-3 block full-width"
						[parentForm]="form.controls.paginator"
						[fullWidth]="true"
						[controlName]="'pageSize'"
						[options]="form.value?.paginator?.pageSizeOptions"
						placeholder="Select a default page size"
						i18n-placeholder="Default Page Size Placeholder@@contentSectionDialogDefaultPageSizePlaceholder"
					>

					</app-select-input>
				</div>
			</ng-container>

			<app-toggle-input
				#visibilityConditionsEnabled
				class="block full-width mb-3"
				[currentValue]="form.value?.visibilityConditions || false"
				[fullWidth]="true"
				[controlName]="'visibilityConditions'"
				label="Enable Visibility Conditions"
				i18n-label="Enable Visibility Conditions Label@@contentSectionDialogEnableVisibilityConditionsLabel"
				(valueChange)="form.controls.visibilityConditions.setValue($event ? form.value?.visibilityConditions || [] : null)"
			>
			</app-toggle-input>

			<button *ngIf="visibilityConditionsEnabled.currentValue" class="block mb-4" mat-flat-button  color="primary" (click)="openVisibilityConditionsDialog()" i18n="Visibility Conditions Configure Label@@adCustomizationEditVisibilityConditionsConfigureLabel">Configure Conditions</button>


		</form>
	</ng-container>

		</div>
	</div>

	<!-- Preview Pane -->
	<div class="preview-pane">
		<div class="preview-header">
			<span class="preview-label">PREVIEW</span>
		</div>
		<div class="preview-content">
			<!-- Live preview using existing ContentSectionComponent -->
			<app-content-section
				*ngIf="previewSection() as contentSection"
				[contentSection]="contentSection"
				[isPreviewMode]="true"
				[preloadedListings]="preloadedTemplates"
			></app-content-section>
		</div>
	</div>
</div>

<!-- Material Dialog Footer (sticky at bottom) -->
<mat-dialog-actions align="end">
	<button color="secondary" mat-flat-button (click)="skip()" i18n="Dialog Action Button@@dialogActionButtonCancelLabel">Cancel</button>
	<button
		mat-flat-button
		color="primary"
		[disabled]="form?.invalid"
		(click)="submit()"
	>
		<span *ngIf="data.contentSection" i18n="Dialog Action Button@@dialogActionButtonSaveLabel">Save</span>
		<span *ngIf="!data.contentSection" i18n="Dialog Action Button@@dialogActionButtonAddLabel">Add</span>
	</button>
</mat-dialog-actions>
